import type { SnowplowEvent } from 'analytics/snowplow/events'
import { activateCampaignEvent } from 'analytics/snowplow/events'

const CHERTO_CAMPAIGN_ID = 'cherto'

export function getExperimentActivationEvent(
  experimentKey: string,
  experiment: App.AnyExperimentDetails,
  bucketingId?: string,
): SnowplowEvent | undefined {
  if (experiment.provider === 'cherto') {
    if (experiment.trackEnrollment === false) {
      return
    }

    // Cherto exposure is tracked through LE's existing Snowplow activation event,
    // not Cherto's native enrollment ingest. bucketingId is the Customer BK id,
    // and only when this experiment is set up on that unit.
    return activateCampaignEvent(
      CHERTO_CAMPAIGN_ID,
      experiment.experimentId ?? experimentKey,
      experiment.variationKey,
      bucketingId,
    )
  }

  if (!experiment.campaignId || !experiment.experimentId) {
    return
  }

  const variationId = experiment.variation?.[experiment.variationKey]
  if (!variationId) {
    return
  }

  return activateCampaignEvent(
    experiment.campaignId,
    experiment.experimentId,
    variationId,
  )
}
